import QueryWhere from '~/scripts/services/model/query-where';
import QueryWhereChildren from '~/scripts/services/model/query-where-children';
import QueryWhereRules from '~/scripts/services/model/query-where-rules';

export default class QueryConditionController {
	/* @ngInject */
	constructor() {
		/** @type {?string} */
		this.condition = null;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?(QueryWhereRules | QueryWhereChildren | QueryWhere)} */
		this.group = null;

		/** @type {any} */
		this.options = undefined;

		/**
		 * @type {?(
		 *   import('../query-builder/query-builder.controller').default
		 *   | import('../query-builder-children/query-builder-children.controller').default
		 * )}
		 */
		this.parent = null;

		/** @type {?import('../query-builder/query-builder.controller').default} */
		this.queryBuilder = null;

		/** @type {?import('../query-builder-children/query-builder-children.controller').default} */
		this.queryBuilderChildren = null;
	}

	disabledConditions() {
		const rules = this.group instanceof QueryWhereRules || this.group instanceof QueryWhereChildren
			? this.group.items : (this.group instanceof QueryWhere ? this.group.rules : []);

		return this.disabled
			|| rules?.some((/** @type {any} */ rule) => rule.value?.length === 1 && rule.value[0].kid === '_KID_');
	}

	$doCheck() {
		const itemsLength = this.group instanceof QueryWhereRules || this.group instanceof QueryWhereChildren
			? this.group.items?.length : (this.group instanceof QueryWhere ? this.group.rules.length : 0);

		if (this.group && itemsLength > 1 && this.group.condition !== 'AND' && this.group.condition !== 'OR') {
			this.group.condition = 'AND';
		}
	}

	$onInit() {
		this.parent = this.queryBuilder || this.queryBuilderChildren;
	}
}
